import { useEffect, useState } from "preact/hooks";
import algolia from "../algolia";
import isArray from 'lodash/isArray';

function Detail(props) {
  const [detail, setDetail] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(function() {
    function init() {
      return algolia().searchIndex.client.multipleGetObjects([
        { objectID: props.id, indexName: algolia().searchIndex.indexName },
      ]).then(function(data) {
        const newDetail = data.results[0];
        if(!isArray(newDetail.categories)) {
          const splitCategories = newDetail.categories.split(';');
          newDetail.categories = splitCategories;
        }
        document.title = newDetail.name;
        setDetail(newDetail);
        setLoading(false);
      })
    }
    if(loading) {
      init();
    }
  }, [props]);

  if (!loading) {
    return (
      <div class="mx-auto block mt-4 bg-transparent text-gray-700 pt-2 px-5 overflow-scroll h-full pb-32">
        <a class="text-base text-gray-800 py-1 px-3 rounded inline-flex items-center mb-4" href="/search">
          <ion-icon class="mr-2" size="lage" name="arrow-back-circle-outline"></ion-icon>
          <span>Back </span>
        </a>
        <div>
          <div class="mb-10 mx-4">
            <img
              class="m-auto border border-gray-400 p-4 rounded-lg w-100"
              src={detail.image_url}
              alt={detail.name}
            />
          </div>
          <div>
            <p class="max-w-md text-center block mx-auto mt-2 text-lg leading-tight font-semibold text-gray-900">
              {detail.name}
            </p>
            <div class="text-center uppercase tracking-wide text-3xl mt-4 text-gray-600 font-bold">
              ${detail.price}
            </div>
            <div class="justify-center flex">
              <a
                native
                href={detail.url}
                class="align-center text-center mt-5 mx-auto uppercase hover:shadow-lg text-white py-3 px-10 rounded"
                style={{
                  background: props.buttonColor ? props.buttonColor : `#63b3ed`
                }}
              >
                View Product
              </a>
            </div>
            <div class="mt-8 mx-4">
              <div class="w-full pt-4 pb-6 rounded overflow-hidden border border-gray-400">
                {/* <div class="px-6 py-4">
                  {detail.categories.map((item, key) => (
                    <span key={key} class="m-1 inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">
                      {item}
                    </span>
                  ))} 
                </div> */}
                <div class="px-6 pb-3">
                  <p class="text-gray-700 text-sm">
                    {detail.description}
                    <a native class="text-blue-600 underline pl-2" href={detail.url}>
                      Read More →
                    </a>
                  </p>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div />;
}

export default Detail;



// WEBPACK FOOTER //
// ./route/Detail.js